<div class="accounting-report-container">

  <div class="pageHeader" id="reportsHeader">
    <span>{{title}}</span>
  </div>

  <div class="warningMessage" *ngIf="warningMessage"><br><li>{{warningMessage}}</li></div>

  <div class="errorMessage" *ngIf="errors?.length">
    <br><br>
    You must correct the following error(s) before proceeding: <br><br>
    <li *ngFor="let message of errors" class="u-padding-5-0">{{message}}</li>
    <br>
    <hr class="hrStyle">
  </div>

  <div class="ui-g daily-reports-container glypha-font">
    <div class="ui-g-6 lableright glypha-font"> Report Name:	</div>
    <div class="ui-g-6 report-name glypha-font">
      {{reportName}}
    </div>
  </div>

  <div class="ui-g" *ngIf="showServicerNumber">
    <div class="ui-g-3 lableright glypha-font">Servicer Number:		</div>
    <div class="ui-g-3">
      <input type="text" maxlength="9" *ngIf="!isExternalUser" [(ngModel)]="servicerNumber"
             fmTextInput>

      <fm-select *ngIf="isExternalUser" [(ngModel)]="servicerNumber"
                 placeholder="&nbsp;"
                 ariaLabelledBy="default"
                 [options]="servicerList"
      ></fm-select>
    </div>
  </div>

  <div class="ui-g" *ngIf="showFanniemaiLoanNumber">
    <div class="ui-g-3 lableright glypha-font">Fannie Mae Loan Number:		</div>
    <div class="ui-g-3">
      <input type="text" maxlength="9"  maxlength="10" [(ngModel)]="fnLnNum"
             fmTextInput>
    </div>
  </div>

  <div class="ui-g" *ngIf="showSellerNumber">
    <div class="ui-g-3 lableright glypha-font">Seller Number:		</div>
    <div class="ui-g-3">
      <input type="text" maxlength="9"  maxlength="10" [(ngModel)]="sellerNumber"
             fmTextInput>
    </div>
  </div>

  <div class="ui-g" *ngIf="reportType==='Monthly Report' || showReportingPeriod">
    <div class="ui-g-6 lableright glypha-font">Reporting Period (YYYYMM):		</div>
    <div class="ui-g-3">
      <div class=" select-style-monthly">
        <fm-select [options]="lastNMonths"
                   placeholder="&nbsp;"
                   [(ngModel)]="monthyear"
                   scrollHeight = "450px"
                   ariaLabelledBy="default">
        </fm-select>
      </div>
    </div>
  </div>

  <div class="ui-g" *ngIf="showSubmissionIdField">
    <div class="ui-g-3 lableright glypha-font">Submission Id:		</div>
    <div class="ui-g-3">
      <fm-select
                [options]="submissionIdList"
                optionLabel="displayString"
                valueLabel="submissionId"
                [(ngModel)]="selectedSubId"
                placeholder="&nbsp;"
                ariaLabelledBy="default"
      ></fm-select>
    </div>
    <div class="ui-g-3">
      <button fmButton [primary]="true" type="button" label="Search" (click)="getSubmissionId()"></button>
    </div>
  </div>

  <div class="ui-g" *ngIf="showActionCodeField">
    <div class="ui-g-6 lableright glypha-font">Action Code:		</div>
    <div class="ui-g-5">
      <div class="select-style">
        <fm-multiselect
          ariaLabelledBy="defaultMultiselect"
          [maxSelectedLabels]="1"
          [filter]="false"
          [(ngModel)]="actnField"
          [options]="actionCodes"
          [displayAll]="false"
          defaultLabel="Choose">
        </fm-multiselect>
      </div>
    </div>
  </div>

  <div class="ui-g" *ngIf="showReportingDate && (reportType==='Daily Report' || reportType==='Adhoc Reports') && !showReportingPeriod">
    <div class="ui-g-3 lableright glypha-font">{{reportDateLabel}}:		</div>
    <div class="ui-g-3">
      <fm-calendar id ="reportDate" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [(ngModel)]="reportingDate"
                   [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
    </div>
  </div>

  <div class="ui-g" *ngIf="showReportStartAndEndDateFields">
    <div class="ui-g-3 lableright glypha-font">Report Start Date:		</div>
    <div class="ui-g-3">
      <fm-calendar id ="reportStartDate" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [(ngModel)]="repStrtDate"
                   [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
    </div>
  </div>

  <div class="ui-g" *ngIf="showReportStartAndEndDateFields">
    <div class="ui-g-3 lableright glypha-font">Report End Date:	</div>
    <div class="ui-g-3">
      <fm-calendar id ="reportEndDate" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [(ngModel)]="repEndDate"
                   [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
    </div>
  </div>

  <div class="ui-g" *ngIf="showSellerName">
    <div class="ui-g-3 lableright glypha-font">Seller Name:		</div>
    <div class="ui-g-3">
      <input type="text" maxlength="30" [(ngModel)]="sellerName"
             fmTextInput>
    </div>
  </div>

  <div class="ui-g" *ngIf="showContractNumber">
    <div class="ui-g-3 lableright glypha-font">Contract Number:		</div>
    <div class="ui-g-3">
      <input type="text" maxlength="9"  maxlength="10" [(ngModel)]="contractNumber"
             fmTextInput>
    </div>
  </div>

  <div class="ui-g reports-button-container">
    <div class="ui-g-10">
      <button fmButton id="btnSubmit" type="submit" [primary]="true" [small]="true" label="Submit"
              class="buttonmargin" (click)="submit()"></button>
      <button fmButton id="btnClear" type="button" label="Clear" [small]="true" (click)="onClear()"
              class="buttonmargin"></button>
      <button fmButton id="btnCancel" type="button" label="Cancel" [small]="true" (click)="onCancelClick()"
              class="buttonmargin"></button>
      <button fmButton id="btnDownload" type="button" label="Download" [small]="true" *ngIf="showDownloadButton"
              class="buttonmargin" (click)="submit()"></button>
      <button fmButton id="btnDownloadDelimited" type="button" label="Download (Delimited)" [small]="true" (click)="onDownloadDat()"
              *ngIf="showDownloadDelimittedAndPdfButton" class="buttonmargin"></button>
      <button fmButton id="btnDownloadPDF" type="button" label="Download (PDF)" [small]="true" (click)="onDownloadPdf()"
              *ngIf="showDownloadDelimittedAndPdfButton"  class="buttonmargin"></button>
      <button fmButton id="btnDownloadEXCEL" type="button" label="Download (EXCEL)" [small]="true" (click)="onDownloadEXCEL()"
              *ngIf="showDownloadExcelButton"  class="buttonmargin"></button>
    </div>
  </div>

  <fm-dialog header="{{fileName}}" [alignLeft]="true" [(visible)]="displayDialog" [modal]="true" [width]="1000"
             [responsive]="true" [dismissableMask]="true">
    <fm-header-template>
      <i class="fmi fmi-print report-print" title="Print" aria-hidden="true" (click)="reportPrint()"></i>
      <i class="fmi fmi-download download-button" title="Download" aria-hidden="true" (click)="downloadFile()"></i>
    </fm-header-template>
    <div id="pdfRenderer" allowFullScreen="true" class="iframe-container">
      <iframe *ngIf="safePdfURL" width="100%" height="100%" id ="pdfRendererIframe" title="PDFViewer" [src]="safePdfURL"></iframe>
    </div>

  </fm-dialog>
</div>

